export default __webpack_public_path__ + "images/EY.030d77e.png";